export class Menu {
    constructor(
        public name: string,
        public icon: string,
        public label: string,
        public link: string,
        public isClick: boolean,
        public disable: boolean = false
    ) { }
}